import { Component, OnInit, HostListener, Renderer2, ViewChild, ElementRef } from '@angular/core';
import { HomeService } from '../_services/home.service';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import {DomSanitizer, SafeHtml, Title} from '@angular/platform-browser';
import { ViewportScroller } from '@angular/common';
import { AuthenticationService } from '../_services/index';
import { GoogleAnalyticsService } from '../_services/google-analytics.service';


@Component({
  selector: 'app-article-view',
  templateUrl: './article-view.component.html',
  styleUrls: ['./article-view.component.scss']
})
export class ArticleViewComponent implements OnInit {
  articleData: any;
  articleId: any;
  articleTitle: any;
  articleExternalId: any;
  searchdata: any;
  selectedValue: any;
  searchArticle: any = [];
  i18n: any;
  keyword = 'name';
  data = [];
  topArticles : any;
  lastUpdated : any;
  searchKey : any;
  openCounterPk : any;
  isFeedbackSuccess : boolean = false;
  currentPage: number = 1;
  searchKeyword: any;
  searchBanner: any;
  searchTextboxNote: any;
  searchTextboxHover: any;
  searchButtonHover: any;
  hideKbSearch: boolean= false;
  parentPk: any;
  topics: any;
  names: any;
  pk: any;
  articleTag:any;
  name: any;
  parent: any;
  topic: any;
  topArticleTitle: any;
  caseAlertMessage: string;
  alert: boolean = false;
  delayed: boolean = false;
  innerWidth: number;
  content: SafeHtml;
  selectedText: any;
  template: any;
  kb: any = [];
  articleView: any;

  @HostListener('click', ['$event'])
  onClick(e) {
  console.log(e.srcElement.id);
  const currentURL =this.router.url;
  var composed = e.composedPath();
  if(e.srcElement.id?.includes(currentURL) || ((e.srcElement.id.length === 0 && e.srcElement.localName === "strong" || e.srcElement.localName === "span") && e.srcElement.parentElement.id?.includes(currentURL) && !(e.srcElement.parentElement.id?.includes("#top")) )){
   const id = e.srcElement.id.length === 0 ? e.srcElement.parentElement.id : e.srcElement.id ;
    this.goToElement(id.split('#')[1]);
  }
  else if(e.srcElement.id?.includes(currentURL)  || (e.srcElement.id.length === 0 && e.srcElement.parentElement.id?.includes(currentURL)) || composed.some(({ id }) => id?.includes('#top')) == true){
  const id = e.srcElement.id.length === 0 ? e.srcElement.parentElement.id : e.srcElement.id ;
  if(id?.includes("#top") ||  composed.some(({ id }) => id?.includes('#top')) == true )
  this.scrollToTop();
 }
}

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = window.innerWidth;
    console.log("Inner width = ", this.innerWidth);
  }


  constructor(private homeService: HomeService, private router: Router,
    private authenticationService: AuthenticationService, private activatedRoute: ActivatedRoute,private route: ActivatedRoute,
     private domSanitizer: DomSanitizer,private renderer: Renderer2,private viewportScroller: ViewportScroller, private gaService : GoogleAnalyticsService) {
    this.activatedRoute.queryParams.subscribe(params => {
      this.articleId = params['articleId'];
      this.viewArticle(this.articleId);
      this.pk=params['pk']
      this.articleTag=params['articleTag']
      this.parent=params['childPk']
      this.i18n = homeService.session.get('i18n');
      this.getTopArticles();
      this.currentPage = params['currentPage'];
      this.searchKeyword = params['selectedValue']
    });
  }

  goToElement(id){
    this.viewportScroller.scrollToAnchor(id);
  }
  scrollToTop(){
    window.scroll(0,0);
  }
 
  ngOnInit() {  
    this.kbSearchConfig();
    this.getAllArticle();
    this.innerWidth = window.innerWidth;
    this.homeService.getTopArticleTitle().subscribe(res =>{
      this.topArticleTitle = res.return_body.title;
    })
}

kbSearchConfig(){
  this.homeService.getKbSearchConfiguration().subscribe(res => {
    this.searchBanner = res.return_body.searchBanner;
    this.searchTextboxNote = res.return_body.searchTextboxNote;
    this.searchTextboxHover = res.return_body.searchTextboxHoverNote;
    this.searchButtonHover = res.return_body.searchButtonHoverNote;
  });
}

  viewArticle(id) {
      this.homeService.getViewArticles(id).subscribe(res => {
      let article = res.return_body.article
      this.articleTitle = article.article_title
      this.gaService.setPageTitle(this.articleTitle);
      // Code for indexing the page 
      const template = this.renderer.createElement('template');
      template.innerHTML = article.article_content.trim();
      const currentURL = this.router.url.split('#')[0];
      const anchorNodes: NodeList = template.content.querySelectorAll('a');
      const anchors:any  = Array.from(anchorNodes);
      
      for (const anchor of anchors) {
        let runtimevar = anchor.href.split('%')[1];
        let runtimevar1 = anchor.href.split('}')[0];
        if(runtimevar == "7Bruntime.custom.kb.article.link" || runtimevar1 == "${runtime.custom.kb.article.link"){
          let host = anchor.href.split('$')[0];
          let url =  this.router.url.split('=')[0];
          let arId = anchor.href.split('}')[1] || anchor.href.split('D')[1];
          let hrefId = host + 'shp' + url + "=" + arId;
          if(hrefId !== undefined && hrefId !== null ){
            const href: string = `${hrefId}`;
            this.renderer.setProperty(
              anchor,
              'href',
              `${href}`
            );
            this.renderer.setProperty(
              anchor,
              'id',
              'javascript:void(0)'
            );
            this.renderer.setProperty(
              anchor,
              'target',
              '_blank'
            );
          }
        }
        if(anchor.toString()?.includes(window.location.hostname)){
          let hrefId = anchor.toString().split('#')[1];
        if(hrefId !== undefined && hrefId !== null ){
          const href: string = `${currentURL}#${hrefId}`;
          this.renderer.setProperty(
            anchor,
            'id',
            `${href}`
          );
          this.renderer.setProperty(
            anchor,
            'href',
            'javascript:void(0)'
          );
          this.renderer.setProperty(
            anchor,
            'target',
            ''
          );
        }
        }
      }
      this.selectedValue = this.domSanitizer.bypassSecurityTrustHtml(template.innerHTML);
      this.articleExternalId = article.orginal_key
      this.lastUpdated=  article.last_updated
      this.openCounterPk= res.return_body.kbOpenCounterPk
    },
    (error) =>{
      // for Default Page title
      this.gaService.setPageTitle("KB Article");
    });
  }
   removeHTML(str){ 
    var tmp = document.createElement("DIV");
    tmp.innerHTML = str;
    return tmp.textContent || tmp.innerText || "";
}
  getAllArticle() {
    let totalTopics = [];
      this.homeService.getChildren(this.pk).subscribe(res => {
      this.topics = res;
      this.articleView = res.return_body[0].kbData.items;
        for (let i = 0; i < 5; i++) {
          totalTopics = this.articleView[i];
          this.kb = this.kb.concat(totalTopics);
        }
      var onlyText=this.removeHTML(this.articleTag)
      onlyText.toLowerCase
      this.names= res.return_body;
      for(var val of this.names){
        if(val.articleTag==onlyText){
          this.name=val.stepName
        }
      }
    });
  }
  getTopArticles() {    
      this.homeService.getTopArticles().subscribe(res => {
      this.topArticles = res.return_body;
    });
  }

  search(searchKey){
    this.router.navigate(['/' + this.router.url.split('/')[1] + '/searchresults'], { queryParams: { selectedValue:searchKey, currentPage: 0  }});
  }
  searchResult(){
    this.router.navigate(['/' + this.router.url.split('/')[1] + '/searchresults'], { queryParams: { currentPage: this.currentPage, selectedValue: this.searchKeyword} });
  }

  selectEvent(item) {
    this.searchKey = item.name;
    this.search(this.searchKey);
  }
  
  onKeyEnterSearch(event: any, searchkeyWrd: any) {
    this.search(searchkeyWrd);
  }

  onChangeSearch(val: string) {
    this.selectedText = val;
    this.data = [];
    if (val != '') {
      this.homeService.getSearchData(val).subscribe(res => {
        this.data = [];
        res.return_body.map((response, index) => {
          this.data.push({ id: index, name: response });
        })
      });
    }
  }

  handleNavigation(pathValue) {
    if(pathValue){
        this.router.navigate([this.router.url.split("/")[1],pathValue]);  
    }
}
printPage() {
  window.print();
}
  getFeedback(status: any){
      this.homeService.getFeedback(this.openCounterPk,status).subscribe(res => {
        if(this.isFeedbackSuccess = true)
        {
          this.isFeedbackSuccess = this.i18n._value['shp.articles.thanksYou'];
        }
       })
     }
     ngAfterViewInit() {
      this.caseMessage();
    }

     caseMessage() {
      this.caseAlertMessage = sessionStorage.getItem('alertMessage')
      if (this.caseAlertMessage) {
        this.alert = true
      }
      setInterval(() => {
        this.delayed = true
        this.alert = false
        sessionStorage.removeItem('alertMessage')
      }, 5000);
    }  
}